import React from "react";
import "./Home.css";
import leader7 from "./images/7.jpeg";
import leader8 from "./images/8.jpeg";
import leader9 from "./images/9.jpeg";
import leader10 from "./images/10.jpeg";

function Community() {

    return (
        <div style={{ background: "white", minHeight: "100vh", padding: "40px 20px" }}>
            <div className="container">

                <div className="text-center mb-5">
                    <h1 style={{ color: "#667eea", fontSize: "2.5rem", fontWeight: "bold" }}>
                        ಕರ್ನಾಟಕ ರಾಜ್ಯ ವೀರಶೈವ ಲಿಂಗಾಯತ ನೌಕರರ ಕ್ಷೇಮಾಭಿವೃದ್ಧಿ ಸಂಘ (ರಿ.)
                    </h1>
                    <div style={{ color: "#764ba2", fontSize: "1.3rem", marginTop: "15px" }}>
                        ಜಿಲ್ಲಾ ಘಟಕ, ಮೈಸೂರು – ಸಮುದಾಯ ವೇದಿಕೆ
                    </div>
                </div>

                <div className="card shadow-lg border-0" style={{ borderRadius: "15px", padding: "40px", background: "white" }}>

                    <h3 className="text-center mb-4" style={{ color: "#667eea", fontWeight: "bold" }}>
                        ನಮ್ಮ ಸಂಘದ ಬಗ್ಗೆ
                    </h3>

                    <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
                        <b>ವೀರಶೈವ ಲಿಂಗಾಯತ ನೌಕರರ ಕ್ಷೇಮಾಭಿವೃದ್ಧಿ ಸಂಘ, ಮೈಸೂರು</b>
                    </p>

                    <p style={{ fontSize: "1.05rem", lineHeight: "1.8" }}>
                        <b>"ಕಾಯಕವೇ ಕೈಲಾಸ, ಸೇವೆಯೇ ಉಸಿರು"</b> ಎಂಬ ಪವಿತ್ರ ತತ್ವದಡಿ,
                        2014ರಿಂದ ಮೈಸೂರು ಜಿಲ್ಲೆಯಲ್ಲಿ ಅತ್ಯಂತ ಕ್ರಿಯಾಶೀಲವಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತಿರುವ
                        ನಮ್ಮ ಸಂಘವು ಇಂದು ಸಮಾಜದ ಶಕ್ತಿಯ ಸಂಕೇತವಾಗಿ ಹೊರಹೊಮ್ಮಿದೆ.
                    </p>

                    <p style={{ fontSize: "1.05rem", lineHeight: "1.8" }}>
                        ಕಳೆದ ಹನ್ನೆರಡು ವರ್ಷಗಳಿಂದ ಸಂಘದ ಅಧ್ಯಕ್ಷರು, ಕಾರ್ಯದರ್ಶಿಗಳು ಮತ್ತು ಸರ್ವ
                        ಪದಾಧಿಕಾರಿಗಳು ಪರಸ್ಪರ ವಿಶ್ವಾಸ ಹಾಗೂ ಒಗ್ಗಟ್ಟಿನಿಂದ ಹತ್ತು-ಹಲವು
                        ಸಮಾಜಮುಖಿ ಕಾರ್ಯಗಳಲ್ಲಿ ತೊಡಗಿಸಿಕೊಂಡಿರುವುದು ನಮ್ಮೆಲ್ಲರಿಗೂ ಹೆಮ್ಮೆಯ ವಿಷಯ.
                        ಸಮಾಜದ ಮುಖಂಡರ ಬೆಂಬಲ ಮತ್ತು ವಿವಿಧ ಮಠ-ಮಾನ್ಯಗಳ ಪರಮಪೂಜ್ಯ ಶ್ರೀಗಳವರ
                        ಕೃಪಾಶೀರ್ವಾದವು ಸಂಘಕ್ಕೆ "ಆನೆ ಬಲ" ನೀಡಿದೆ.
                    </p>

                    <h4 className="mt-4 mb-3" style={{ color: "#764ba2", fontWeight: "bold" }}>2026ರ ಹೊಸ ಅಧ್ಯಾಯ</h4>

                    <p style={{ fontSize: "1.05rem", lineHeight: "1.8" }}>
                        ಸಂಘದ ಈ ಶ್ರೇಯೋಭಿವೃದ್ಧಿಯನ್ನು ಇನ್ನಷ್ಟು ಉತ್ತುಂಗಕ್ಕೇರಿಸಲು,
                        2026ನೇ ಸಾಲಿನ ನೂತನ ಪದಾಧಿಕಾರಿಗಳಾಗಿ ಕೆಳಗಿನ ಗಣ್ಯರು ಅವಿರೋಧವಾಗಿ ಆಯ್ಕೆಯಾಗಿದ್ದಾರೆ:
                    </p>

                    <ul style={{ fontSize: "1.05rem", lineHeight: "2" }}>
                        <li><b>ಅಧ್ಯಕ್ಷರು:</b> ಶ್ರೀ ಶಿವಕುಮಾರ್ ಬಿ. ಆರ್.</li>
                        <li><b>ಕಾರ್ಯದರ್ಶಿಗಳು:</b> ಶ್ರೀ ಮಹದೇವಪ್ರಸಾದ್</li>
                        <li><b>ಖಜಾಂಚಿಗಳು:</b> ಶ್ರೀ ಬಾಗಳಿ ಮಹೇಶ್</li>
                    </ul>

                    <p style={{ fontSize: "1.05rem", lineHeight: "1.8" }}>
                        ಸಂಘಟಿತ ಶಕ್ತಿಯೇ ಸಮಾಜದ ಪ್ರಗತಿಯ ಮೂಲ ಮಂತ್ರ.
                        ನೂತನ ಸಾರಥ್ಯದಲ್ಲಿ ನಮ್ಮ ಸಂಘವು ನೌಕರರ ಸಮಸ್ಯೆಗಳಿಗೆ ಧ್ವನಿಯಾಗಲಿ,
                        ಶರಣರ ತತ್ವಗಳನ್ನು ಜನಸಾಮಾನ್ಯರಿಗೆ ತಲುಪಿಸುವಲ್ಲಿ ಯಶಸ್ವಿಯಾಗಲಿ
                        ಮತ್ತು ಸಮಾಜದ ಕಟ್ಟಕಡೆಯ ವ್ಯಕ್ತಿಗೂ ಸೇವೆಯ ಫಲ ಸಿಗುವಂತಾಗಲಿ ಎಂದು ಆಶಿಸುತ್ತೇವೆ.
                    </p>

                    <p style={{ fontSize: "1.05rem", lineHeight: "1.8" }}>
                        ನೂತನ ಪದಾಧಿಕಾರಿಗಳಿಗೆ ಹೃದಯಪೂರ್ವಕ ಅಭಿನಂದನೆಗಳು ಮತ್ತು
                        ಮುಂದಿನ ಎಲ್ಲಾ ಸತ್ಕಾರ್ಯಗಳಿಗೆ ಶುಭ ಹಾರೈಕೆಗಳು.
                    </p>

                    <p className="text-center mt-4" style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#667eea" }}>
                        ಸೇವಾ ಹಾದಿಯಲ್ಲಿ ನಾವೆಲ್ಲರೂ ಒಂದಾಗೋಣ..
                    </p>

                    <p className="text-center mt-3" style={{ fontSize: "1.05rem" }}>
                        ಧನ್ಯವಾದಗಳೊಂದಿಗೆ,<br />
                        ವೀರಶೈವ ಲಿಂಗಾಯತ ನೌಕರರ ಕ್ಷೇಮಾಭಿವೃದ್ಧಿ ಸಂಘ<br />
                        ಜಿಲ್ಲಾ ಘಟಕ, ಮೈಸೂರು
                    </p>

                </div>

                {/* ===== LEADERS SECTION ===== */}
                <div className="mt-5">
                    <h3 className="text-center mb-4" style={{ color: "#667eea", fontWeight: "bold" }}>ನೌಕರ ಸಂಘದ ತೊಡೆವಲವರು</h3>
                    <div className="row justify-content-center">
                        {[
                            { img: leader9, name: "ಶ್ರೀಯುತ ಸಿ.ಡಿ. ಬಸವರಾಜು", designation: "ಅಧ್ಯಕ್ಷರು (2014–2017)", location: "ಕಾನಕಪುರ ಸಂಘ ಶಾಖೆ" },
                            { img: leader10, name: "ಶ್ರೀಯುತ ಎನ್. ಪುಟ್ಟಸ್ವಾಮಪ್ಪ", designation: "ಅಧ್ಯಕ್ಷರು (2017–2018)", location: "ಮಂಡ್ಯ ಸಂಘ" },
                            { img: leader8, name: "ಶ್ರೀಯುತ ಎನ್.ಕೆ. ಸ್ವಾಮಿ", designation: "ಅಧ್ಯಕ್ಷರು (2018–2021)", location: "ಶ್ರೀನಗರ" },
                            { img: leader7, name: "ಶ್ರೀಯುತ ಕೆಂಪಣ್ಣ", designation: "ಅಧ್ಯಕ್ಷರು (2021–2024)", location: "ಮಂಡ್ಯ" }
                        ].map((leader, idx) => (
                            <div key={idx} className="col-md-3 col-sm-6 mb-4">
                                <div className="card shadow border-0 text-center" style={{ borderRadius: "15px", overflow: "hidden" }}>
                                    <img src={leader.img} alt={leader.name} style={{ width: "100%", height: "250px", objectFit: "cover" }} />
                                    <div className="card-body">
                                        <h5 style={{ fontWeight: "bold", color: "#667eea", fontSize: "1rem" }}>{leader.name}</h5>
                                        <p className="mb-1" style={{ fontSize: "0.9rem", color: "#764ba2" }}>{leader.designation}</p>
                                        <p className="mb-0" style={{ fontSize: "0.85rem", color: "#666" }}>{leader.location}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Community;
